import type { RegisterDto } from '@nestjs-boilerplate/types';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

import { setAuthState } from '@/stores/auth.store';

import { register } from '../api/auth.api';

export function useRegister() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (data: RegisterDto) => register(data),
    onSuccess: (response) => {
      setAuthState(response.accessToken, response.user);
      toast.success('Registration successful! Check your email to verify your account.');
      // New users must verify their email before account setup.
      navigate({ to: '/verify-email' });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Registration failed. Please try again.');
    },
  });
}
